import {
  format,
  startOfMonth,
  endOfMonth,
  subMonths,
  startOfYear,
  endOfYear,
} from "date-fns";
import { use, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiAction } from "../Redux/Slices/uiSlice";

const ranges = [
  {
    label: "This Month",
    getDates: () => ({ from: startOfMonth(new Date()), to: new Date() }),
  },
  {
    label: "Last Month",
    getDates: () => {
      const lastMonth = subMonths(new Date(), 1);
      return { from: startOfMonth(lastMonth), to: endOfMonth(lastMonth) };
    },
  },
  {
    label: "Last 3 Months",
    getDates: () => {
      const from = subMonths(new Date(), 3);
      return { from, to: new Date() };
    },
  },
  {
    label: "Last 6 Months",
    getDates: () => {
      const from = subMonths(new Date(), 6);
      return { from, to: new Date() };
    },
  },
  {
    label: "Last Year",
    getDates: () => {
      const lastYear = subMonths(new Date(), 12);
      return { from: startOfYear(lastYear), to: endOfYear(lastYear) };
    },
  },
  {
    label: "Last Financial Year",
    getDates: () => {
      const today = new Date();
      const currentYear = today.getFullYear();
      const fyStart = new Date(currentYear - 1, 3, 1); // April 1 of last year
      const fyEnd = new Date(currentYear, 2, 31); // March 31 of this year
      return { from: fyStart, to: fyEnd };
    },
  },
];

export default function DateRangeButtons({ onSelect }) {
  const [isActive, setIsActive] = useState(0);
  const actIndex = useSelector((state) => state.uiReducers.actIndex);
  const dispatch = useDispatch();
  const handleSelect = (index, label, dates) => {
    dispatch(uiAction.setActIndex(index));
    onSelect(label, dates);
  };

  // console.log("actIndex", actIndex);
  return (
    <ul className="sidebar-list d-flex flex-wrap gap-2 p-3 m-0">
      {ranges.map((range, i) => {
        const { from, to } = range.getDates();
        return (
          <li key={i} className="sidebar-list-item list-unstyled">
            <button
              onClick={() => handleSelect(i, range.label, { from, to })}
              className={`px-3 py-1 rounded-pill fw-semibold shadow-sm transition-all ${
                i === actIndex
                  ? "btn btn-success bg-gradient text-white hover-shadow"
                  : "btn btn-light border text-secondary hover-shadow"
              }`}
            >
              <div className="d-flex flex-column align-items-center">
                <span>{range.label}</span>
                <small>{`${format(from, "dd-MM-yyyy")} to ${format(
                  to,
                  "dd-MM-yyyy"
                )}`}</small>
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
